<style>
  button {
    color: #000;
  }
  div {
    /*background-color: #aaa;*/
  }
  img {
    margin: 0.2em;
    height: 2em;
  }
  .nav {
    background-color: transparent;
    box-shadow: none;
  }
  .selected {
    background-color: #eee;
    box-shadow: inset 0.1em 0.1em 0.1em #333, inset -0.1em -0.1em 0.1em #ccc;
  }
  .login {
    box-shadow: 0.1em 0.1em 0.2em #111;
    color: #fff;
  }
</style>

<script>
  import { afterUpdate } from 'svelte';
  import config from "../../config";
  import auth from "../auth";
  import { 
    auth_client, auth_logged_in,
    lang,
    panel_selected
  } from '../store';
  import util from "../util";
  
  function goto_appname() {
    window.location.reload();
  }
  function toggle_selected() {
    if ($panel_selected === nav_id) {
      $panel_selected = '';
    } else {
      $panel_selected = nav_id;
    };
  }
  async function login() {
    await auth.login({redirect_uri: window.location.href});
  }
  function window_resize() {
    if (!$auth_logged_in) {
      if (window.innerWidth < 800) {
        login_text = util.caption($lang, 'nav_panel', 'login_no_break');
      } else {
        login_text = util.caption($lang, 'nav_panel', 'login_with_break');
      }
    }
  }
  
  afterUpdate(() => {
    window_resize();
  });
  
  export let nav_id;
  
  let login_text;
</script>

<svelte:window on:resize={window_resize}/>

{#if nav_id === 'appname'}
  <div>
    <img src='zs-logo.png' alt='Zemnieku Saeima logo' on:click={goto_appname}>
  </div>
  <!-- <button class='nav' on:click={goto_appname}>{util.caption($lang,'nav_panel',nav_id)}</button> -->
{:else if nav_id === 'profile' && !$auth_logged_in}
  <button class='login' title={`App version: ${config.version}`} on:click={login}>{@html login_text}</button>
{:else}
  <button class='nav' class:selected='{$panel_selected === nav_id}' on:click={toggle_selected}>{util.caption($lang,'nav_panel',nav_id)}</button>
{/if}
